import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// initial state
const state: file.state.FileState = {
    files: []
};

export default {
    state,
    actions,
    getters,
    mutations,
};
